export const propRules = {
  rules: {
    heading: "Zasady obiektu",
    subheading:
      "Ustaw godziny check-in i check-out, które zostaną przekazane gościowi podczas check-in.",
    cloneTitleNoun: "godziny",
    cloneItemNoun: "godziny",
    bulkNoticePrefix:
      "Ta zmiana zostanie zastosowana do wszystkich obiektów ({count}) powiązanych z",
    checkinLabel: "Check-in",
    checkoutLabel: "Check-out",
    defaultCheckin: "Domyślnie 15:00",
    defaultCheckout: "Domyślnie 12:00",
    saving: "Zapisywanie…",
    save: "Zapisz",
    toasts: {
      loadError: "Nie udało się wczytać danych oferty.",
      bulkApplied: "Zasady zastosowane do obiektów: {count}",
      saveSuccess: "Zasady zostały zapisane",
      bulkPartialError: "Niektórych obiektów nie udało się zaktualizować",
      saveError: "Błąd podczas zapisywania zasad",
    },
  },
  services: {
    cloneTitleNoun: "wyposażenie i udogodnienia",
    cloneItemNoun: "wyposażenie i udogodnienia",
    toasts: {
      saveSuccess: "Udogodnienia zostały zapisane",
      saveError: "Błąd podczas zapisywania udogodnień",
    },
  },
  maintenance: {
    title: "Konserwacja obiektu",
    scopeProperty: "Cały obiekt",
    scopeUnits: "Wybrane jednostki",
    selectUnits: "Wybierz jednostki",
    dateFrom: "Od",
    dateTo: "Do",
    closeArrivals: "Zablokuj przyjazdy (CTA)",
    closeDepartures: "Zablokuj wyjazdy (CTD)",
    applying: "Stosowanie...",
    apply: "Zastosuj konserwację",
    removing: "Usuwanie...",
    remove: "Usuń konserwację",
    toasts: {
      rangeScopeRequired:
        "Uzupełnij zakres dat oraz zakres obowiązywania (jednostki lub obiekt).",
      applied: "Konserwacja została zastosowana.",
      applyError: "Błąd podczas stosowania konserwacji.",
      removed: "Konserwacja została usunięta.",
      removeError: "Błąd podczas usuwania konserwacji.",
    },
  },
  propMaintenance: {
    title: "Konserwacja obiektu",
    scopeProperty: "Cały obiekt",
    scopeUnits: "Wybrane jednostki",
    selectUnits: "Wybierz jednostki",
    dateFrom: "Od",
    dateTo: "Do",
    closeArrivals: "Zablokuj przyjazdy (CTA)",
    closeDepartures: "Zablokuj wyjazdy (CTD)",
    applying: "Stosowanie...",
    apply: "Zastosuj konserwację",
    removing: "Usuwanie...",
    remove: "Usuń konserwację",
    toasts: {
      rangeScopeRequired:
        "Uzupełnij zakres dat oraz zakres obowiązywania (jednostki lub obiekt).",
      applied: "Konserwacja została zastosowana.",
      applyError: "Błąd podczas stosowania konserwacji.",
      removed: "Konserwacja została usunięta.",
      removeError: "Błąd podczas usuwania konserwacji.",
    },
  },
};
